import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Image, Icon } from 'semantic-ui-react';
import { Button } from 'components';

import classNames from 'classnames/bind';
import styles from './CheckEmail.css';
const cx = classNames.bind(styles);

/* 메일 발송 결과 확인 컴포넌트 */
class CheckEmailResult extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isSend, isReSend, movePasswdReset, reSendEmail } = this.props;
    let resultView = '';
    // 계정작업 없이 두번째 단계로 넘어옴
    if (isSend === 0) {
      return null;
    } else if (isSend === 1) {
      resultView = (
        <div className={cx('comment-content')}>
          <div className={cx('info-text')}>
            <Image src={'/img/icon_pw.png'} />
            <span className={cx('ml-10')}>
              {defineMessages(formatMessage({ id: 'CheckEmailResult_1', defaultMessage: '비밀번호 재설정 메일 발송' }))}
            </span>
          </div>
          <div className={cx('double-grey', 'font-size-11', 'mt-13')}>
            {defineMessages(
              formatMessage({
                id: 'CheckEmailResult_2',
                defaultMessage: '메일로 전송된 링크를 클릭하여 비밀번호를 재설정하세요.'
              })
            )}
          </div>
        </div>
      );
    } else if (isSend === 2) {
      resultView = (
        <div className={cx('comment-content')}>
          <div className={cx('info-text')}>
            <Image src={'/img/icon_fail.png'} />
            <span className={cx('ml-10 mb-4')}>
              {defineMessages(
                formatMessage({ id: 'CheckEmailResult_3', defaultMessage: '비밀번호 재설정 메일 발송 실패' })
              )}
            </span>
          </div>
          <div className={cx('double-grey', 'font-size-11', 'mt-13')}>
            {defineMessages(
              formatMessage({
                id: 'CheckEmailResult_4',
                defaultMessage: '메일발송이 실패하였습니다. 다시 시도해 주십시오.'
              })
            )}
          </div>
        </div>
      );
    }

    return (
      <div className={cx('checkEmailResult', 'content-inner')}>
        <div className={cx('comment-area', 'checkEmailResult')}>{resultView}</div>
        {/* 재시도 버튼 */}
        <div className={cx('button-area')}>
          {isSend === 1 && (
            <div className={cx('button-inner')}>
              <Button className={cx('bt-brand')} onClick={movePasswdReset}>
                {defineMessages(formatMessage({ id: 'CheckEmailResult_5', defaultMessage: '로그인' }))}
              </Button>
            </div>
          )}
          <div className={cx('button-inner')}>
            <Button className={cx('bt-grey')} onClick={reSendEmail}>
              {defineMessages(formatMessage({ id: 'CheckEmailResult_6', defaultMessage: '재전송' }))}
            </Button>
          </div>
          <div>
            {!!isReSend && (
              <div className={cx('reSendMailMessage', { 'color-red': isReSend === 2 })}>
                {isReSend === 1
                  ? defineMessages(
                      formatMessage({ id: 'CheckEmailResult_7', defaultMessage: '비밀번호 설정 메일 재전송 성공' })
                    )
                  : defineMessages(
                      formatMessage({ id: 'CheckEmailResult_8', defaultMessage: '비밀번호 설정 메일 재전송 실패' })
                    )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

CheckEmailResult.propTypes = {
  isSend: PropTypes.number,
  isResend: PropTypes.number,
  movePasswdReset: PropTypes.func,
  reSendEmail: PropTypes.func
};

export default injectIntl(CheckEmailResult);



// WEBPACK FOOTER //
// ./src/script/components/pwReset/CheckEmailResult.js